// The drifting mesh-gradient background, ported from the landing page. Fixed
// behind all content; purely decorative.
export function MeshBackground() {
  return (
    <div className="mesh-bg" aria-hidden="true">
      <div className="blob blob-1" />
      <div className="blob blob-2" />
      <div className="blob blob-3" />
    </div>
  )
}
